import React from "react";
import { Box } from "@mui/material";
import ContactTabCard from "./ContactTabCard";
import EmploymentStatusSelect from "../../CRM/contacts/EmploymentStatusSelect";
import ContactEmploymentSection from "../../CRM/contacts/employment/ContactEmploymentSection";
import FundEmploymentInfo from "../../CRM/contacts/employment/FundEmploymentInfo";
import { MimshakData } from "../../../interfaces/DTO/mimshakData";
import { Contact } from "../../../interfaces/DTO/crm/contact";

interface ContactEmploymentInfoProps {
  contact: Contact;
  contactMimshakData: MimshakData[];
}

/** תעסוקה – כרטיס לקוח: אווטר ושם, סטטוס תעסוקתי, ותעסוקה אחרונה (שכיר / עצמאי / ח.פ) */
const ContactEmploymentInfo: React.FC<ContactEmploymentInfoProps> = ({ contact, contactMimshakData }) => (
  <ContactTabCard contact={contact}>
    {/* Employment Status - always a dropdown */}
    <Box sx={{ mb: 2.5 }}>
      <EmploymentStatusSelect contact={contact} />
    </Box>

    <ContactEmploymentSection contact={contact} />

    {/* the latest employer in the funds (click - add it to the last employment) and the occupations */}
    <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
      <FundEmploymentInfo contact={contact} mimshakData={contactMimshakData} />
    </Box>
  </ContactTabCard>
);

export default ContactEmploymentInfo;
